"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _XXF5DFSGcjs = require('../__chunks/XXF5DFSG.cjs');
require('../__chunks/5OZ7J4C2.cjs');
require('../__chunks/OTCKJ4OK.cjs');


var _7XPYSHN7cjs = require('../__chunks/7XPYSHN7.cjs');
require('../__chunks/F7D3HWZN.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/menu/menu-separator.tsx
var TagName = "hr";
var useMenuSeparator = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useMenuSeparator2({ store, ...props }) {
    const context = _XXF5DFSGcjs.useMenuContext.call(void 0, );
    store = store || context;
    props = _7XPYSHN7cjs.useCompositeSeparator.call(void 0, { store, ...props });
    return props;
  }
);
var MenuSeparator = _PTOCUU2Dcjs.forwardRef.call(void 0, function MenuSeparator2(props) {
  const htmlProps = useMenuSeparator(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.MenuSeparator = MenuSeparator; exports.useMenuSeparator = useMenuSeparator;
